import { CIcon } from '~/icons/types'

export const ciBuilders: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M7.01 14.07H3.62a.5.5 0 0 0 0 1h3.39a.5.5 0 0 0 0-1Zm0-1.804H3.62a.5.5 0 0 0 0 1h3.39a.5.5 0 0 0 0-1Z'
    },
    {
      d:
        'M23.994 16.59v-.046L21.965 2.13a.5.5 0 0 0-.5-.43h-3.919a.5.5 0 0 0-.363.155l-6.228 6.571h-.721a.5.5 0 0 0-.5.5v1.558H1.8a.5.5 0 0 0-.5.5v5.37a.5.5 0 0 0 .5.5h1.654v1H2.226a2.228 2.228 0 0 0 0 4.454h13.721a2.226 2.226 0 0 0 2.101-3.09 2.229 2.229 0 0 0-2.101-1.365H14.72v-1h1.652a.5.5 0 0 0 .5-.5v-3.126a.51.51 0 0 0-.037-.189l-1.138-2.8 2.981-4.95 3.247 12.856-2.025 3.157h-.753a.5.5 0 0 0 0 1H23.5a.5.5 0 0 0 .5-.5v-5.19c0-.01-.006-.01-.006-.02ZM2.236 21.301h-.015a1.316 1.316 0 1 1 .015 0Zm8-4.448h3.484v1H4.454v-1h5.782Zm-6.28-1H2.3v-4.369h7.434v4.37h-5.78.002Zm10.134 5.448H4.083a2.21 2.21 0 0 0 0-2.453h10.008a2.215 2.215 0 0 0-.001 2.453Zm1.857-2.453a1.227 1.227 0 0 1 .005 2.454h-.014a1.227 1.227 0 0 1 .009-2.454Zm-.075-3h-5.138V9.426h1.2v3.275a1.711 1.711 0 0 0 1.713 1.7h2.225v1.447Zm0-2.528v.081h-2.225a.71.71 0 0 1-.709-.709V9.426h1.35l1.584 3.894Zm2.568-9.577L15.227 9.08l-.14-.343a.5.5 0 0 0-.463-.31h-2.292L17.761 2.7h1.308l-.629 1.042Zm.964.337.832-1.379h.8l1.944 13.8-.314.49-3.262-12.91ZM23 21.301h-1.914L23 18.318v2.983Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'builders',
  type: 'thin'
}
